var React = require('react');

function PrintSlash (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M176 104.26V48h240v32a16 16 0 0 0 16 16h32v96H289.53L538 384h22a16 16 0 0 0 16-16V256a64 64 0 0 0-64-64V77.25a32 32 0 0 0-9.37-22.63L457.37 9.37A32 32 0 0 0 434.74 0H160a32 32 0 0 0-32 32v35.16zM496 248a24 24 0 1 1-24 24 24 24 0 0 1 24-24zm-64 216l59.29 45.72A31.48 31.48 0 0 1 480 512H160a32 32 0 0 1-32-32v-96H80a16 16 0 0 1-16-16V256a63.83 63.83 0 0 1 29.47-53.75L328 384H176v80z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M636.64 480.55L617 505.82a16 16 0 0 1-22.46 2.81L6.18 53.9a16 16 0 0 1-2.81-22.45L23 6.18a16 16 0 0 1 22.47-2.81L633.82 458.1a16 16 0 0 1 2.82 22.45z","className":"fa-primary","key":2})]);
}

PrintSlash.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = PrintSlash;

PrintSlash.default = PrintSlash;
